<template>
  <div>
    <SpFilterForm :model="formData" size="small" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="item_name">
        <el-input v-model="formData.item_name" clearable placeholder="请输入商品名称" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="ums_activity_id">
        <el-input v-model="formData.ums_activity_id" clearable placeholder="请输入国补优惠编码" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="ums_discount_code">
        <el-input v-model="formData.ums_discount_code" clearable placeholder="请输入国补优惠活动code" />
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder
      ref="finder"
      row-key="activity_id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      reserve-selection
      no-selection
      :hooks="{
        beforeSearch
      }"
    >
      <template slot="tableTop">
        <el-button type="primary" size="medium" @click="addChange">添加</el-button>
      </template>
    </SpFinder>
    <GoodsSelect
      :items-visible="visible"
      :is-spu=true
      :support_gov_subsidy="1"
      :item-tier="itemNormal"
      row-key="goods_id"
      :get-status="itemStatus"
      :rel-items-ids="subsidyItems"
      @chooseStore="chooseItemsAction"
      @closeStoreDialog="handleClose"
    ></GoodsSelect>
    <DealerSelect
      :store-visible="dealerVisible"
      :is-valid="true"
      :rel-data-ids="relDealers"
      :get-status="dealerStatus"
      @chooseStore="chooseDealer"
      @closeStoreDialog="closeDealerDialog"
    />
  </div>
</template>
<script>
import { useDialog } from '@shopex/finder'
import GoodsSelect from '@/components/goodsSelect'
import DealerSelect from '@/components/function/dealerSelect'
import { tableSetting } from './config'
import { List, createActivityCodes, setActivityItems, setDealerItems } from './api'

export default {
  components: {
    GoodsSelect,
    DealerSelect
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  data () {
    return {
      table_url: List,
      visible: false,
      rowData: {},
      subsidyItems: [],
      itemStatus: false,
      itemNormal: [
        'normal',
      ],
      formData: {
        item_name: '',
        ums_activity_id: '',
        ums_discount_code: ''
      },
      dealerVisible: false,
      dealerStatus: false,
      relDealers: [],
    }
  },
  mounted() {
  },
  methods: {
    beforeSearch (param) {
      return {
        ...param,
        page_size: param.pageSize,
        ...this.formData
      }
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    onReset() {
      this.formData = {}
      this.refresh()
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    addItems (row) {
      console.log(row)
      this.visible = true
      this.rowData = row
      this.itemStatus = true
      this.subsidyItems = []
    },
    async handleClose () {
      this.visible = false
      this.itemStatus = false
      this.rowData = {}
      this.subsidyItems = []
    },
    async chooseItemsAction (data) {
      if (data === null || data.length <= 0) return this.$message.error('请选择商品')
      const ids = data.map(item => item.goods_id)
      await setActivityItems({
        activity_id: this.rowData.activity_id,
        goods_id: ids
      })
      this.$message.success('添加成功')
      this.refresh()
      this.handleClose()
    },
    addChange () {
      useDialog(null, {
        title: `新增国补优惠编码`,
        width: '50%',
        component: () => import('./comps/createForm.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '提交', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (arg) => {
        if(arg) {
          try {
            await createActivityCodes(arg)
            this.$message.success('新增成功')
            this.refresh()
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    showGoods (row) {
      console.log(row, 'row')
      useDialog(null, {
        title: `查看商品列表`,
        width: '70%',
        component: () => import('./comps/goodList.vue'),
        orgData: {
          activity_id: row.activity_id,
          vm: this
        },
        actions: []
      })
    },
    showDealer (row) {
      useDialog(null, {
        title: `查看经销商列表`,
        width: '70%',
        component: () => import('./comps/dealerList.vue'),
        orgData: {
          activity_id: row.activity_id,
          vm: this
        },
        actions: []
      })
    },
    addDealerAction(row) {
      this.dealerVisible = true
      this.dealerStatus = true
      this.rowData = row
    },
    closeDealerDialog () {
      this.dealerVisible = false
      this.dealerStatus = false
      this.rowData = {}
      this.relDealers = []
    },
    async chooseDealer (data) {
      if (data === null || data.length <= 0) return
      const ids = data.map(item => item.dealer_id)
      await setDealerItems({
        activity_id: this.rowData.activity_id,
        dealer_id: ids
      })
      this.$message.success('添加成功')
      this.refresh()
      this.closeDealerDialog()
    },
  }
}
</script>

<style scoped lang="scss">
.nationalmanage-header {
  display: flex;
  justify-content: space-between;
  align-items: center
}
</style>
<style lang="scss">

</style>

